var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.zoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.zoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('zone')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.zoneList,
      "name": "zone",
      "id": "zone",
      "multiple": _vm.multiple(),
      "placeholder": "Select Zone",
      "label": "hubzonename",
      "track-by": "hubzoneid",
      "optionHeight": 100,
      "preselect-first": false,
      "hide-selected": true
    },
    on: {
      "input": _vm.addHubData
    },
    model: {
      value: (_vm.zone),
      callback: function($$v) {
        _vm.zone = $$v
      },
      expression: "zone"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zone')),
      expression: "errors.has('zone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Zone is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub / SVC")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.hubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.hubList,
      "placeholder": "Select Hub / Svc",
      "multiple": _vm.multipleHub(),
      "disabled": _vm.disableHub,
      "name": "HubId",
      "id": "HubId",
      "label": "HubName",
      "track-by": "HubID",
      "optionHeight": 100,
      "hide-selected": false
    },
    on: {
      "input": _vm.addRSCOwner
    },
    model: {
      value: (_vm.HubId),
      callback: function($$v) {
        _vm.HubId = $$v
      },
      expression: "HubId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RSC / SVC")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.RSCLoading
    },
    on: {
      "update:active": function($event) {
        _vm.RSCLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.RSCList,
      "placeholder": "Select RSC / SVC",
      "multiple": _vm.multipleRSC(),
      "disabled": _vm.disableHub,
      "name": "RSCName",
      "id": "RSCName",
      "label": "HubName",
      "track-by": "HubName",
      "optionHeight": 100,
      "hide-selected": false
    },
    on: {
      "input": _vm.addRSCOwner
    },
    model: {
      value: (_vm.RSCName),
      callback: function($$v) {
        _vm.RSCName = $$v
      },
      expression: "RSCName"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disableRSCOwner),
      expression: "disableRSCOwner"
    }],
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RSC Owner")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.RSCOwnerLoading
    },
    on: {
      "update:active": function($event) {
        _vm.RSCOwnerLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rscowner),
      expression: "rscowner"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "rscowner",
      "id": "rscowner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rscowner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.RSCOwnerList), function(rscowner_obj) {
    return _c('option', {
      domProps: {
        "value": rscowner_obj
      }
    }, [_vm._v(_vm._s(rscowner_obj.OutSourcingMasterID) + " - " + _vm._s(rscowner_obj.OutSourcingName) + " - " + _vm._s(rscowner_obj.EffectiveFromDate) + " To " + _vm._s(rscowner_obj.EffectiveToDate))])
  })], 2)], 1)], 1), _vm._v(" "), (_vm.rscowner.length <= 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From ( Delivery ) Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.rscowner.length<=0 ? 'required' : ''))),
      expression: "`${rscowner.length<=0 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromDate')),
      expression: "errors.has('fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("From date is required. ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rscowner.length <= 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To ( Delivery ) Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.rscowner.length<=0 ? 'required' : ''))),
      expression: "`${rscowner.length<=0 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('toDate')),
      expression: "errors.has('toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("To date is required. ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1",
      "title": "Open"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6",
      "title": "Close"
    }
  }, [_vm._v("Close")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Dispute/ Other Reason AWB No & Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-left": "18px",
      "margin-right": "3px"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b', [_vm._v("SR Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "159px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "77px"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.SRDetails) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.SRDetails.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.SRDetails), function(srdetails, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }, [_vm._v("\n                              " + _vm._s(srdetails.srName) + " " + _vm._s(srdetails.comment ? ' - ' + srdetails.comment : '') + "\n                            ")]), _vm._v(" "), (!val.ReasonAmt) ? _c('td', [_c('table', _vm._l((_vm.getSRAWBNo(val.awb, srdetails.awbNo)), function(row) {
        return _c('tr', {
          key: row.awbno
        }, [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "159px"
          }
        }, [_vm._v(_vm._s(row.awbno))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "77px"
          }
        }, [_vm._v(_vm._s(row.amount))])])
      }))]) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s(srdetails.srAmt))]) : _vm._e()])
    }))])]) : (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-left": "13px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "200px"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "159px"
      }
    }, [_vm._v(_vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "77px"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt) + "\n                            "), ((val.ReasonID == 363 || val.ReasonID == 165) && val.ReasonURL != undefined && val.ReasonURL != '') ? _c('a', {
      on: {
        "click": function($event) {
          _vm.generateUrl(val.ReasonURL)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "15px",
        "color": "#4b8cbb",
        "margin": "0px 0px 0px 10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])])]) : (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.awb.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.awb), function(row, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), (_vm.fnfLogDetails.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Deposite Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Deposite Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Finance Confirmed Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Deposite Slip's")])])])]), _vm._v(" "), _c('tbody', [(_vm.fnfLogDetails.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fnfLogDetails), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.bankdeposit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.bankdepositdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.financeconfirmdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_c('a', {
      attrs: {
        "href": val.file.filePath,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_c('i', {
      staticClass: "fa fa-download"
    })])])])])
  })], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    ref: "myRecExcModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.RecExcModalShow),
      callback: function($$v) {
        _vm.RecExcModalShow = $$v
      },
      expression: "RecExcModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Self Debit/Recovery & Exception AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))])])
    }))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(val.amount))])])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.commentModalShow),
      callback: function($$v) {
        _vm.commentModalShow = $$v
      },
      expression: "commentModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.cType))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "0.9rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.comment))])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Result\n                (  \n                  "), _c('font', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('span', {
    staticClass: "dot1"
  }), _vm._v(" System Closure\n                    "), _c('span', {
    staticClass: "dot2"
  }), _vm._v(" Tax Payment/Imprest\n                    "), _c('span', {
    staticClass: "dot3"
  }), _vm._v(" Amount Mismatched\n                    "), _c('span', {
    staticClass: "dot4"
  }), _vm._v(" RSC Vendor\n                  ")]), _vm._v("\n                  )\n\n                "), (_vm.exportf == false && _vm.resultCount > 0) ? _c('span', {
    staticStyle: {
      "margin-left": "20%"
    }
  }, [_c('font', {
    staticStyle: {
      "font-size": "12px",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Report available in few seconds..")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportf),
      expression: "exportf"
    }],
    staticStyle: {
      "margin-left": "25%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.exportHubWiswData()
      }
    }
  }, [_vm._m(2)])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "24",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.CODLedgerReports), function(CODLedger_List, index) {
    return _c('tr', {
      class: ("" + ((CODLedger_List.createdby == 'schedular@xpressbees.com') || (CODLedger_List.deposittype == '' && ![366,367,168,169].includes(CODLedger_List.financereasonid)) ? 'scheduler' : '' || CODLedger_List.reasonid == 65 ? 'other' : '' || ([84,124,187,218,125,374,175].includes(CODLedger_List.financereasonid)) ? 'mismatched' : ([366,367,168,169].includes(CODLedger_List.financereasonid)) ? 'fnfrsc' : ''))
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.pageno + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.zonename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.rscowner))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.rscpan))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.hubLocationType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.deliverydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.openingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.receivable))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.exceptionamt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showRecExcAWBNo('exception', CODLedger_List.exceptionamt, CODLedger_List.awbno)
        }
      }
    }, [_vm._v(_vm._s(CODLedger_List.exceptionamt))]) : _vm._e(), _vm._v(" "), (CODLedger_List.exceptionamt == 0) ? _c('span', [_vm._v(_vm._s(CODLedger_List.exceptionamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.bankdeposit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.otherAmt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(CODLedger_List.otherArr)
        }
      }
    }, [_vm._v(_vm._s(CODLedger_List.otherAmt))]) : _vm._e(), _vm._v(" "), (CODLedger_List.otherAmt == 0) ? _c('span', [_vm._v(_vm._s(CODLedger_List.otherAmt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.cardissueamt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(CODLedger_List.cardawbno)
        }
      }
    }, [_vm._v(_vm._s(CODLedger_List.cardissueamt))]) : _vm._e(), _vm._v(" "), (CODLedger_List.cardissueamt == 0) ? _c('span', [_vm._v(_vm._s(CODLedger_List.cardissueamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.svcoutstandingamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.bank))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.deposittype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.depositdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.financeconfirmamount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.balanceLogic))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.financeconfirmdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.comment) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(CODLedger_List.comment, 'c')
        }
      }
    }, [_vm._v(_vm._s(CODLedger_List.financereason))]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null].includes(CODLedger_List.comment))),
        expression: "(['',null].includes(CODLedger_List.comment))"
      }]
    }, [_vm._v(_vm._s(CODLedger_List.financereason))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.StatusVal))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.transactionid && CODLedger_List.transactionid != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(CODLedger_List.transactionid, 't')
        }
      }
    }, [_vm._v("view")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null, 0].includes(CODLedger_List.transactionid))),
        expression: "(['',null,0].includes(CODLedger_List.transactionid))"
      }]
    }, [_vm._v(_vm._s(CODLedger_List.transactionid))])])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" Hub Wise COD Closure Report\n          ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Zone")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub/SVC Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("RSC Owner")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("RSC PAN")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Location Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Opening Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Receivable "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Deposit Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Other Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("SVC Outstanding Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Confirmed Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Outstanding Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Confirmed Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Closed by")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction Id")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c3544e","hasScoped":true}!./src/views/components/hubwisecodreport/hubwisecodreport.component.html
// module id = 670
// module chunks = 1